/* eslint-disable react/display-name */
import React, { useState, useEffect } from "react"
import uuid4 from "uuid4";
import MetaTags from 'react-meta-tags';
import {
  Container,
  Modal,
  ModalBody,
  Form
} from "reactstrap"
import DatatableTables from "components/tables/DatatableTables";
import { TEMPEMP, QR_CODE, DINER_STATUS, OPTIONS_URL } from 'helpers/url_helper'
import { post, get, del } from 'helpers/api_helper'
import Swal from 'sweetalert2';
import toastr from "toastr";
import "toastr/build/toastr.min.css";

const formObj = {
  name: '',
  phone: '',
  location: '',
  canteen: '',
  remark: ''
}

const TempEmployee = () => {
  const [loading, setLoading] = useState(false);
  const [guestData, setGuestData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [submitBtnActive, setSubmitBtnActive] = useState(false);
  const [formData, setFormData] = useState(formObj);
  const [dinerData, setDinerData] = useState(null);
  const [options, setOptions] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState("");
  const [selectedCanteen, setSelectedCanteen] = useState("");

  
  const handleDineStatus = async (row, type) => {
    toastr.options = {
      positionClass: "toast-top-right",
      timeOut: 5000,
      extendedTimeOut: 1000,
      closeButton: false,
      debug: false,
      progressBar: false,
      preventDuplicates: false,
      newestOnTop: true,
      showEasing: 'swing',
      hideEasing: 'linear',
      showMethod: 'fadeIn',
      hideMethod: 'fadeOut',
      showDuration: 300,
      hideDuration: 1000
    };
    let a = false;

    if(type === 'lunch'){
      setGuestData(prev => prev.map((item) => item.id === row.id ? { ...item, is_lunch: !item.is_lunch } : item));
      a = row.is_lunch ? false: true;
      if(a){
        toastr.success(`${row.name} allowed to get lunch`);
      }else{
        toastr.error(`${row.name} dismissed to get lunch`);
      }
    }
    if(type === 'dinner'){
      setGuestData(prev => prev.map((item) => item.id === row.id ? { ...item, is_diner: !item.is_diner } : item));
      a = row.is_diner ? false: true;
      if(a){
        toastr.success(`${row.name} allowed to get dinner`);
      }else{
        toastr.error(`${row.name} dismissed to get dinner`);
      }
    }

    const obj = {
      diner: row.phone,
      type: type,
      status: a,
      is_guest: false,
      is_temp: true
    }

    const res = await post(DINER_STATUS, obj);
  }
  
  const columns = [{
    dataField: 'sr',
    text: '#',
    sort: true,
  }, {
    dataField: 'name',
    text: 'Name',
    sort: true
  },{
    dataField: 'actions2',
    text: 'Lunch',
    sort: true,
    formatter: (cell, row) => {
      return (
        <div className="form-check form-switch">
          <input type="checkbox" className="form-check-input"  id={`lunchbtn-${row.id}`} checked={row.is_lunch ? true: false} onChange={() => handleDineStatus(row, 'lunch')} />
        </div>
      );
    },
  },{
    dataField: 'actions3',
    text: 'Dinner',
    sort: true,
    formatter: (cell, row) => {
      return (
        <div className="form-check form-switch">
          <input type="checkbox" className="form-check-input" id={`dinerbtn-${row.id}`} checked={row.is_diner ? true: false}  onChange={() => handleDineStatus(row, 'dinner')} />
        </div>
      );
    },
  },{
    dataField: 'phone',
    text: 'Contact',
    sort: true
  }, {
    dataField: 'location',
    text: 'Location',
    sort: true
  },  {
    dataField: 'actions',
    text: 'Actions',
    formatter: (cell, row) => {
      return (
        <>
          <button onClick={() => setDinerData(row)} className="btn btn-success">
            <i className="fab fa-whatsapp"></i>{" "} Issue Token
          </button>
        </>
      );
    },
  }];

  const issueToken = async(_number) => {
    const obj = {
      "diner": dinerData?.code,
      "_number": _number,
      "is_guest": 1
    }
    const res = await post(`${QR_CODE}`, obj);
    if(res?.success) {
      setDinerData(null)
    }
  }

  const fetchData = async () => {
    setLoading(true);
    const res = await get(`${TEMPEMP}`);
    if(res?.success) {
      const options = await get(`${OPTIONS_URL}`);
      setGuestData(res?.body)
      setLoading(false);
      setOptions(options?.body);
    }
  }

  useEffect(() => {
    fetchData();
  }, [])

  const addRecord = async (data) => {
    setSubmitBtnActive(true);
    const res = await post(TEMPEMP, data);
    if(res.success){
      fetchData()
      setFormData(formObj)
      setSubmitBtnActive(false);
      setModalOpen(false);
    }
  }

  const editRecord = async (data) => {
    Swal.fire({
      title: "Currently Not Allowed!",
      text: "",
      icon: "warning"
    });
  }

  const removeRecord = async (data) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
      preConfirm: async () => {
        try {
          const res = await del(`${EMPLOYEE}/${data.code}`);
          if (res.body === 1) {
            Swal.fire(
              'Deleted!',
              'Your file has been deleted.',
              'success'
            );
          } else {
            throw new Error('Delete failed');
          }
        } catch (error) {
          Swal.fire(
            'Error!',
            'There was a problem deleting your file.',
            'error'
          );
        }
      }
    });
  };
  
  const handleAddGuest = async () => {
    const res = await post(GUEST, guestData);
    if(res.success){
      setModalOpen(false);
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Temporary Employees | Advance Dental Export Canteen Management</title>
        </MetaTags>
        <Container fluid>
          <DatatableTables title={"Temporary Employees"} columns={columns} rows={guestData} isAdd={true} addBtnLabel={"Add T.Employees"} callback={() => setModalOpen(true)} />
          
          <Modal
            isOpen={modalOpen}
          >
            <div className="modal-header">
              <h5 className="modal-title mt-0" id="modal-title">Temporary Employees</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => handleAddGuest}><span aria-hidden="true">×</span></button>
            </div>
            <Form
              onSubmit={(v) => {
                v.preventDefault();
                addRecord(
                  {...formData,
                    name: v.target.name.value,
                    phone: v.target.phone.value,
                    location: v.target.location.value,
                    canteen: v.target.canteen.value
                  })
              }}
            >
              <ModalBody>
                <div className="row mb-3">
                  <div className="col-6">
                    <label htmlFor="name" className="form-label imp">Full Name</label>
                    <input name="name" id="name" placeholder="Enter full name" required type="text" className="form-control" />
                  </div>
                  <div className="col-6 mt-2">
                    <label htmlFor="phone" className="form-label imp">Mobile</label>
                    <input name="phone" id="phone" placeholder="Enter Mobile" required type="text" className="form-control" />
                  </div>
                  <div className="col-6 mt-2">
                    <label htmlFor="location" className="form-label imp">Location</label>
                    {/* <input name="location" id="location" placeholder="Please Select Location" required type="text" className="form-control" /> */}
                    <select
                      id="dropdown"
                      className="form-control"
                      required
                      value={selectedLocation}
                      name="location"
                      onChange={(e) =>  setSelectedLocation(e.target.value)}
                      style={{ padding: "8px", borderRadius: "4px"}}
                    >
                      <option key='c1' value="">---</option>
                      {options?.locations?.map((option) => (
                        <option key={`${uuid4()}_${option.value}`} value={option.code}>
                          {option.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-6 mt-2">
                    <label htmlFor="canteen" className="form-label imp">Canteen</label>
                    {/* <input name="canteen" id="canteen" placeholder="Please Select Canteen" required type="text" className="form-control" /> */}
                    <select
                      id="dropdown"
                      className="form-control"
                      required
                      value={selectedCanteen}
                      name="canteen"
                      onChange={(e) =>  setSelectedCanteen(e.target.value)}
                      style={{ padding: "8px", borderRadius: "4px"}}
                    >
                      <option key='c1' value="">---</option>
                      {options?.canteens?.map((option) => (
                        <option key={`${uuid4()}_${option.value}`} value={option.code}>
                          {option.title}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </ModalBody>
              <div className="modal-footer">
                <button type="button" className="btn btn-light" onClick={() => setModalOpen(false)}>Close</button>
                <button type="submit" className="btn btn-primary" disabled={submitBtnActive}>Submit</button>
              </div>
            </Form>
          </Modal>


          {/* Whastapp Numner */}
          <Modal
            isOpen={dinerData ? true: false}
          >
            <div className="modal-header">
              <h5 className="modal-title mt-0" id="modal-title">Issue Dine Token</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => setDinerData(null)}><span aria-hidden="true">×</span></button>
            </div>
            <Form
              onSubmit={(v) => {
                v.preventDefault();
                issueToken(v.target.wp_num.value)
              }}
            >
              <ModalBody>
                <div className="row mb-3">
                  <div className="col-12">
                    <label htmlFor="wp_num" className="form-label imp">Please Enter Mobile Number</label>
                    <input name="wp_num" id="wp_num" placeholder="Please Enter Mobile Number" required type="text" className="form-control" />
                  </div>
                  <div className="mt-2 col-12">
                    <table className="table table-bordered">
                      <tbody>
                        <tr>
                          <td>Diner Name</td>
                          <td>{dinerData?.name}</td>
                        </tr>
                        <tr>
                          <td>Diner Phone</td>
                          <td>{dinerData?.phone}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </ModalBody>
              <div className="modal-footer">
                <button type="button" className="btn btn-light" onClick={() => setDinerData(null)}>Close</button>
                <button type="submit" className="btn btn-primary" >Submit</button>
              </div>
            </Form>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default TempEmployee;

